import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const useToastPromise = () => {
  const navigate = useNavigate();
  return ({
    promise = null,
    pendingMessage = "Processing...",
    successMessage = (data) => "Operation successful.",
    errorMessage = (data) => "Operation failure.",
    finishPromise = () => {},
    failPromise,
  }) => {
    if (!promise) {
      console.debug("No promise passed to ToastPromise.");
      return;
    }
    const toastId = toast.promise(promise, {
      pending: pendingMessage,
      success: {
        render({ data }) {
          console.debug(data);
          return successMessage(data);
        },
      },
      error: {
        render({ data }) {
          console.debug(data);
          return errorMessage(data);
        },
      },
    });
    promise
      .then((result) => {
        console.debug(result);
        finishPromise(result);
      })
      .catch((err) => {
        console.debug(err);
        if (failPromise) {
          failPromise(err);
        } else {
          navigate("/login");
        }
      });
    return toastId;
  };
};
